import { token } from "functions/Helper";
import InActiveList from "views/Sector/InActive";
import InDraft from "views/Sector/InDraft";
import Published from "views/Sector/Published";
import DirectionsBoatIcon from "@material-ui/icons/DirectionsBoat";
import { CreateSector } from "views/Sector/Create";
import { EditSector } from "views/Sector/Edit";
import { DeleteSector } from "views/Sector/Delete";
import { ViewSector } from "views/Sector/View";
import { PublishSector } from "views/Sector/Publish";
import { DeactivateSector } from "views/Sector/Deactivate";
import { EditSectorBookingConfiguration } from "views/Sector/EditBookingConfiguration";

const sector = () => {
  let views = [];

  if (token["master.sectors.read"] === "allowed" || token.is_admin === "True") {
    views = views.concat([
      {
        path: "/Sector/InDraft",
        name: "InDraft",
        mini: "ID",
        component: InDraft,
        layout: "/admin"
      },
      {
        path: "/Sector/Published",
        name: "Published",
        mini: "PU",
        component: Published,
        layout: "/admin"
      },
      {
        path: "/Sector/InActive",
        name: "InActive",
        mini: "IA",
        component: InActiveList,
        layout: "/admin"
      }
    ]);
  }

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Sector",
        icon: DirectionsBoatIcon,
        state: "SectorCollapse",
        views: views
      }
    ];
  return [];
};

const sectorHidden = () => {
  let views = [];

  if (
    token["master.sectors.write"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views = views.concat([
      {
        path: "/Sector/Create",
        name: "Create Sector",
        component: CreateSector,
        layout: "/admin"
      },
      {
        path: "/Sector/Edit",
        name: "Edit Sector",
        component: EditSector,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/Sector/Delete",
        name: "Delete Sector",
        component: DeleteSector,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      }
    ]);
  }

  if (token["master.sectors.read"] === "allowed" || token.is_admin === "True") {
    views.push({
      path: "/Sector/Detail",
      name: "View Sector",
      component: ViewSector,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  if (
    token["master.sectors.publish"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/Sector/Publish",
      name: "View Sector",
      component: PublishSector,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  if (
    token["master.sectors.deactivate"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/Sector/Deactivate",
      name: "View Sector",
      component: DeactivateSector,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  if (
    token["booking.sectors.write"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/Sector/EditBookingConfiguration",
      name: "Edit Booking Configuration",
      component: EditSectorBookingConfiguration,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Sector Hidden",
        state: "sectorHidden",
        hideInSidebar: true,
        views: views
      }
    ];
  return [];
};

export { sector, sectorHidden };
